import React from "react";
import { LuDownload } from "react-icons/lu";
import api from "../api"; // ✅ axios instance

const GiftModal = ({
  gifts,
  setGifts,
  isAddingGift,
  setIsAddingGift,
  isEditingGift,
  setIsEditingGift,
  editIndex,
  setEditIndex,
  newGift,
  setNewGift,
  setIsDeleteModalOpen,
  setDeleteIndex,
}) => {
  // ✅ Save Gift to Backend
  const handleSaveGift = async () => {
    if (!newGift.title.trim() || !newGift.desc.trim()) {
      alert("Please enter heading and description");
      return;
    }

    try {
      const res = await api.post("/admin/gift-earn/", {
        title: newGift.title,
        description: newGift.desc,
      });

      setGifts([
        ...gifts,
        {
          id: res.data.id,
          title: res.data.title,
          desc: res.data.description,
          couponCode: res.data.coupon_code,
          createdAt: res.data.created_at,
        },
      ]);

      resetForm();
      setIsAddingGift(false);
    } catch (error) {
      console.error("Error saving gift:", error);
      alert("Failed to save gift. Please try again.");
    }
  };

  // ✅ Update Gift in Backend
  const handleUpdateGift = async () => {
    if (!newGift.title.trim() || !newGift.desc.trim()) {
      alert("Please enter heading and description");
      return;
    }

    const giftToUpdate = gifts[editIndex];
    if (!giftToUpdate || !giftToUpdate.id) {
      alert("Invalid gift selected for update.");
      return;
    }

    try {
      const res = await api.patch(
        `/admin/gift-earn/${giftToUpdate.id}/`,
        {
          title: newGift.title,
          description: newGift.desc,
        }
      );

      const updatedGifts = [...gifts];
      updatedGifts[editIndex] = {
        ...giftToUpdate,
        title: res.data.title,
        desc: res.data.description,
      };

      setGifts(updatedGifts);
      resetForm();
      setIsEditingGift(false);
      setEditIndex(null);
    } catch (error) {
      console.error("Error updating gift:", error);
      alert("Failed to update gift. Please try again.");
    }
  };

  const resetForm = () => {
    setNewGift({ title: "", desc: "" });
  };

  // ✅ Reusable Add/Edit Form
  const renderForm = (isEdit = false) => (
    <div className="add-gift-form">
      <h4>{isEdit ? "Edit Heading" : "Add Heading"}</h4>
      <input
        type="text"
        placeholder="Enter Heading..."
        value={newGift.title}
        onChange={(e) => setNewGift({ ...newGift, title: e.target.value })}
      />

      <h4>{isEdit ? "Edit Description" : "Add Description"}</h4>
      <input
        type="text"
        placeholder="Enter Description..."
        value={newGift.desc}
        onChange={(e) => setNewGift({ ...newGift, desc: e.target.value })}
      />

      <button
        className="gift-save-btn"
        onClick={isEdit ? handleUpdateGift : handleSaveGift}
      >
        <LuDownload className="add-package-icon" color="#EBA8BF" /> Save
      </button>
    </div>
  );

  return (
    <div className="notification-modal">
      {/* Header */}
      {isAddingGift ? (
        <div className="notification-header gift-header">
          <button className="back-btn" onClick={() => setIsAddingGift(false)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
              <path
                fill="#fff"
                d="m7.825 13l4.9 4.9q.3.3.288.7t-.313.7q-.3.275-.7.288t-.7-.288l-6.6-6.6q-.15-.15-.213-.325T4.426 12t.063-.375t.212-.325l6.6-6.6q.275-.275.688-.275t.712.275q.3.3.3.713t-.3.712L7.825 11H19q.425 0 .713.288T20 12t-.288.713T19 13z"
              />
            </svg>
          </button>
          <span className="add-gift-title">Add Gift & Earn</span>
        </div>
      ) : isEditingGift ? (
        <div className="notification-header gift-header">
          <button className="back-btn" onClick={() => setIsEditingGift(false)}>
            <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25">
              <path
                fill="#fff"
                d="m7.825 13l4.9 4.9q.3.3.288.7t-.313.7q-.3.275-.7.288t-.7-.288l-6.6-6.6q-.15-.15-.213-.325T4.426 12t.063-.375t.212-.325l6.6-6.6q.275-.275.688-.275t.712.275q.3.3.3.713t-.3.712L7.825 11H19q.425 0 .713.288T20 12t-.288.713T19 13z"
              />
            </svg>
          </button>
          <span className="add-gift-title">Edit Gift & Earn</span>
        </div>
      ) : (
        <div className="notification-header gift-header">
          <div className="gift-title">
            <span>Gift & Earn</span>
          </div>
          <button
            className="header-gift-add-btn"
            onClick={() => setIsAddingGift(true)}
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 24 24"
            >
              <path
                fill="none"
                stroke="#fff"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M8 12h4m4 0h-4m0 0V8m0 4v4m0 6c5.523 0 10-4.477 10-10S17.523 2 12 2S2 6.477 2 12s4.477 10 10 10"
              />
            </svg>{" "}
            Add
          </button>
        </div>
      )}

      {/* Forms */}
      {isAddingGift && renderForm(false)}
      {isEditingGift && renderForm(true)}

      {/* Gift List */}
      {!isAddingGift && !isEditingGift && (
        <div className="notification-list">
          {gifts.length === 0 ? (
            <p className="no-gifts">No gifts added yet. Click "Add" to create one.</p>
          ) : (
            gifts.map((gift, index) => (
              <div className="notification-cardTwo gift-card" key={gift.id || index}>
                <div className="gift-card-text">
                  <div className="gift-notification-title">{gift.title}</div>
                  <div className="gift-notification-desc">{gift.desc}</div>
                  <div className="gift-coupon">
                    Coupon Code: <b>{gift.couponCode}</b>
                  </div>
                </div>
                <div className="gift-card-actions">
                  {/* Edit */}
                  <button
                    className="icon-btn"
                    onClick={() => {
                      setEditIndex(index);
                      setNewGift({
                        title: gift.title,
                        desc: gift.desc,
                      });
                      setIsEditingGift(true);
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#F07AA3" d="m7 17.013l4.413-.015l9.632-9.54c.378-.378.586-.88.586-1.414s-.208-1.036-.586-1.414l-1.586-1.586c-.756-.756-2.075-.752-2.825-.003L7 12.583zM18.045 4.458l1.589 1.583l-1.597 1.582l-1.586-1.585zM9 13.417l6.03-5.973l1.586 1.586l-6.029 5.971L9 15.006z"/><path fill="#F07AA3" d="M5 21h14c1.103 0 2-.897 2-2v-8.668l-2 2V19H8.158c-.026 0-.053.01-.079.01c-.033 0-.066-.009-.1-.01H5V5h6.847l2-2H5c-1.103 0-2 .897-2 2v14c0 1.103.897 2 2 2"/></svg>
                  </button>
                  {/* Delete */}
                  <button
                    className="icon-btn"
                    onClick={() => {
                      setDeleteIndex(index);
                      setIsDeleteModalOpen(true);
                    }}
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 24 24"><path fill="#F07AA3" d="M7 21q-.825 0-1.412-.587T5 19V6H4V4h5V3h6v1h5v2h-1v13q0 .825-.587 1.413T17 21zM17 6H7v13h10zM9 17h2V8H9zm4 0h2V8h-2zM7 6v13z"/></svg>
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
      )}
    </div>
  );
};

export default GiftModal;
